import { useTheme } from 'styled-components';

import { Typography } from '@libs/components';

import { PriceDownIcon, PriceUpIcon } from 'src/assets';
import { useTranslation } from 'src/hooks';

import {
  CardDescriptionWrapper,
  CardWrapper,
  PriceIconWrapper,
} from './styles';

type CoinDynamicCardProps = {
  isPriceLow?: boolean;
  amount?: number | string;
  periodLabel: string;
};
const CoinDynamicCard: React.FC<CoinDynamicCardProps> = ({
  isPriceLow,
  amount,
  periodLabel,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const Icon = isPriceLow ? <PriceDownIcon /> : <PriceUpIcon />;
  const periodPreText = isPriceLow
    ? t('coin_details_dynamics_low')
    : t('coin_details_dynamics_high');

  return (
    <CardWrapper>
      <PriceIconWrapper isPriceLow={isPriceLow}>{Icon}</PriceIconWrapper>
      <CardDescriptionWrapper>
        <Typography
          type="bodyButton"
          fontFamily="primaryMedium"
          color={colors.text.secondary}
        >
          {`${periodPreText} (${periodLabel})`}
        </Typography>
        <Typography type="headline" fontFamily="primaryBold">
          {amount}
        </Typography>
      </CardDescriptionWrapper>
    </CardWrapper>
  );
};

export default CoinDynamicCard;
